import { useQuery } from '@tanstack/react-query';

import { blankTemplateJson } from './dutchie-templates/blank-template';
import { blankTemplateHtml } from './dutchie-templates/blank-template-html';
import { productOrBrandSpotlightJson } from './dutchie-templates/product-or-brand-spotlight-json';
import { productOrBrandSpotlightTemplateHtml } from './dutchie-templates/product-or-brand-spotlight-template-html';
import { promotionOrSaleJson } from './dutchie-templates/promotion-or-sale-json';
import { promotionOrSaleTemplateHtml } from './dutchie-templates/promotion-or-sale-template-html';
import { upcomingEventJson } from './dutchie-templates/upcoming-event-json';
import { upcomingEventTemplateHtml } from './dutchie-templates/upcoming-event-template-html';

import type { MarketingTemplatePreset } from '../marketing/campaign-templates/get-campaign-templates';

export function useGetDutchieTemplateQuery() {
  return useQuery({
    queryKey: ['dutchie-email-template'],
    queryFn: dummyFetch,
  });
}

function dummyFetch(): Promise<MarketingTemplatePreset[]> {
  return new Promise((resolve) => {
    setTimeout(() => {
      resolve([
        {
          MarketingTemplatePresetId: null,
          TemplateName: 'Blank',
          JsonBody: JSON.stringify(blankTemplateJson),
          HtmlBody: blankTemplateHtml,
          DeletedAtUtc: null,
          HtmlBodyS3FileName: '',
          IsDeleted: false,
          JsonBodyS3FileName: '',
          LastModifiedDateUtc: null,
          LspId: 0,
          Id: '',
        },
        {
          DeletedAtUtc: null,
          HtmlBody: promotionOrSaleTemplateHtml,
          HtmlBodyS3FileName: '',
          IsDeleted: false,
          JsonBody: JSON.stringify(promotionOrSaleJson),
          JsonBodyS3FileName: '',
          LastModifiedDateUtc: '',
          LspId: 0,
          MarketingTemplatePresetId: null,
          TemplateName: 'Promotion or sale',
          Id: '',
        },
        {
          DeletedAtUtc: null,
          HtmlBody: productOrBrandSpotlightTemplateHtml,
          HtmlBodyS3FileName: '',
          IsDeleted: false,
          JsonBody: JSON.stringify(productOrBrandSpotlightJson),
          JsonBodyS3FileName: '',
          LastModifiedDateUtc: '',
          LspId: 0,
          MarketingTemplatePresetId: null,
          TemplateName: 'Product spotlight',
          Id: '',
        },
        {
          DeletedAtUtc: null,
          HtmlBody: upcomingEventTemplateHtml,
          HtmlBodyS3FileName: '',
          IsDeleted: false,
          JsonBody: JSON.stringify(upcomingEventJson),
          JsonBodyS3FileName: '',
          LastModifiedDateUtc: '',
          LspId: 0,
          MarketingTemplatePresetId: null,
          TemplateName: 'Upcoming event',
          Id: '',
        },
      ]);
    }, 1000);
  });
}
